<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">Ficha em andamento encontrada!</h3>
  </div>
  <div class="modal-footer">
    <div class="text-center">
      <div class="col-md-12" style="margin-bottom: 30px;">
        <button
          type="button"
          class="bt-go btn btn-full-orange"
          style="margin: unset;"
          (click)="load()">
          Recuperar ficha
        </button>
      </div>
      <div class="col-md-12">
        <button
          type="button"
          class="bt-go btn btn-full-orange"
          style="margin: unset;"
          (click)="close()">
          Iniciar nova ficha
        </button>
      </div>
    </div>
  </div>
</div>
